

import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import PropTypes from "prop-types";

import MDBox from "../../MDBox";

import { useMaterialUIController, setLayout } from "../../../Context/mui";

function PageLayout({ background, children }) {
  const [, dispatch] = useMaterialUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "page");
  }, [pathname]);

  return (
    <MDBox
      width="100vw"
      maxWidth="100vw"
      height="100%"
      minHeight="100vh"
      bgColor={background}
      sx={{ background: "radial-gradient(circle,rgba(198, 243, 255, 1) 0%, rgba(238, 251, 255, 1) 100%)" }}
    >
      {children}
    </MDBox>
  );
}

// Setting default values for the props for PageLayout
 

// Typechecking props for the PageLayout
PageLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
};

export default PageLayout;
